import { render, staticRenderFns } from "./VenueBookingSuccess.vue?vue&type=template&id=01c13afa&scoped=true"
import script from "./VenueBookingSuccess.vue?vue&type=script&lang=js"
export * from "./VenueBookingSuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../Vue/course_selecttion_v3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c13afa",
  null
  
)

export default component.exports